import { getStore } from '../redux/store' 
import { showWidget, hideWidget, update, showPageTools } from '../redux/translate/actions'
import React from 'react'

var vsprintf = require('sprintf-js').vsprintf

const store = getStore()

const jsTranslations = {
  'es-ES' : {
    'OP_MAP_SIGN_BACK' : 'Regresar'
  },
  'en-GB' : {
    'OP_MAP_SIGN_BACK' : 'Back'
  }
}

otuApp.translate = {
  showWidget : ( options ) => store.dispatch( showWidget( options ) ),
  hideWidget : ( options ) => store.dispatch( hideWidget( options ) ),
  showPageTools : ( options ) => store.dispatch( showPageTools( options ) ),
  update : ( options ) => store.dispatch( update( options ) ),
  translate : ( options ) => {
    /* 
      Translate some js only tags
    */
    const {
      tag  = null 
    } = options

    const languageTag = otuApp.appState.languageTag

    const string = jsTranslations[languageTag][tag];

    if (typeof string == 'undefined') return 'Tag Undefined'

    return string
  }
}



export function useTranslation( useTranslationOptions = {}) {

  useTranslationOptions = Object.assign( {}, {
    defaultTag : 'span', useTranslationOptions,
    autodetectHtmlTag: true,
    noTag : false,
    __html : false,
    useFunc : false
  }, useTranslationOptions)


  const translations  = ( typeof useTranslationOptions.translations!=='undefined'?useTranslationOptions.translations:{}); 

  const DefaultTag = `${useTranslationOptions.defaultTag}`;

  return function _translate( translationConstant, translateOptions = {} ) {
    
    translateOptions = Object.assign( {}, {
      tag:null,
      sprintf:[]
    }, useTranslationOptions, translateOptions )

    var translation = translationConstant
    var CustomTag = null;
    var result = null;

    if ( typeof translations[ translationConstant ] !=='undefined' ) {
      translation =  translations[ translationConstant ]
    }

    translation = vsprintf(translation,translateOptions.sprintf)

    if ( translateOptions.noTag ) return translation

    const __html = {__html: translation }

    if ( translateOptions.__html ) return html

    if ( translateOptions.autodetectHtmlTag && translateOptions.tag===null ) {
      
      if ( !/<\/?[a-z][\s\S]*>/i.test(translation)) {
        result = translation
      }

      if ( !result && /<\/?(p|div)[\s\S]*>/i.test(translation)) {

        CustomTag = `div`

      }    
    
    }

    if ( !result && translateOptions.tag !== null ) {
      
      var CustomTag = `${translateOptions.tag}`
    
    }

    if ( !result && CustomTag === null ) CustomTag = DefaultTag

    if ( !result ) result = ( <CustomTag className="ttext" dangerouslySetInnerHTML={ __html  }/> )

    if ( translateOptions.useFunc ) {
      return () => result
    } else {
      return result
    }
  
  }
}